import React, { Component } from "react";

import { Translate } from "react-redux-i18n";

import Slider from "../../utils/components/Slider";
import Rating from "../../utils/components/Rating";

import "../../../styles/components/map/filter/StationFilter.scss";

class StationFilter extends Component {
  render() {
    return (
      <div id="stationFilter">
        <div className="filter-item">
          <p>
            <Translate value="mapFilter_priceRange" />
          </p>
          <Slider
            value={this.props.sliders.price.value}
            min={this.props.sliders.price.min}
            max={this.props.sliders.price.max}
            step={this.props.sliders.price.step}
            unit="€"
            onChange={(value) => this.props.onSliderChange("price", value)}
          />
        </div>
        <div className="filter-item">
          <p>
            <Translate value="mapFilter_power" />
          </p>
          <Slider
            value={this.props.sliders.power.value}
            min={this.props.sliders.power.min}
            max={this.props.sliders.power.max}
            step={this.props.sliders.power.step}
            unit="kW"
            onChange={(value) => this.props.onSliderChange("power", value)}
          />
        </div>
        <div className="filter-item">
          <p>
            <Translate value="mapFilter_rating" />
          </p>
          <Rating onRatingChange={this.props.onRatingChange} input />
        </div>
        <div className="filter-item">
          <p>
            <Translate value="mapFilter_stations" />
          </p>
          <div className="stations-container">
            {Object.keys(this.props.stations).map((k) => (
              <div
                key={k}
                className="station"
                onClick={() => this.props.onSelectStation(k)}
              >
                <img
                  src={
                    this.props.stations[k].icons[
                      this.props.stations[k].selected ? 1 : 0
                    ]
                  }
                  alt=""
                />
                <p>
                  {k === "goCharge" ? (
                    <Translate value={`server_goCharge_network`} />
                  ) : (
                    <Translate value={`mapFilter_${k}_station`} />
                  )}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default StationFilter;
